<template lang="pug">
.loading-img
  img(
    :src="img || src" 
    :alt="alt"
    @load="loadSuccessImg"
  )
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      default: null
    },
    src: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: 'image'
    }
  },
  methods: {
    loadSuccessImg($e) {
      const { target } = $e
      if (target.complete) {
        target.parentNode.classList.add('hidden')
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.loading-img
  --bgPos: 0 0
  --bgSize: cover
  --default-url: url(../assets/sectiond.png)

  background-image: var(--default-url)
  background-position: var(--bgImgPos)
  background-size: var(--bgSize)
  background-repeat: no-repeat
  &.hidden
    background-image: none
  img
    width: 100%
    height: 100%
    object-fit: var(--bgSize)
    
</style>



// WEBPACK FOOTER //
// src/components/ImgLoader.vue